import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseTrackListeningScoreChartParams {
  trackId: string;
  date?: Date;
  rangeDays?: number;
  enabled?: boolean;
}

export const useTrackListeningScoreChart = ({
  trackId,
  date,
  rangeDays,
  enabled = true,
}: UseTrackListeningScoreChartParams) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  return useTRPCQuery(
    trpcMusicAPI.tracks.listeningTrend.queryOptions(
      { trackId, date, rangeDays, ...shareTokenInput },
      { enabled: Boolean(trackId) && enabled }
    )
  );
};
